import Axios from "axios";
import store from "../store";
Axios.interceptors.request.use(function (config) {
    var user = store.getters.user;
    if (user) {
        if (!config.params) {
            config.params = {
                token: user.token
            };
        }
        else {
            config.params.token = user.token;
        }
    }
    return config;
});
